import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import Checkbox from '../../../../../../../components/Form/Checkbox'
import InstagramAccountSkeleton from './Skeleton'

import {
  facebookPagesIsLoadingSelector,
  facebookPagesSelector,
  facebookPagesWasLoadedSelector
} from '../../../../../../../modules/selectors/socialAccounts'

import { INCLUDE_LINKED_INSTAGRAM_ACCOUNT, LINKED_INSTAGRAM_ACCOUNT, SOCIAL_MEDIA_POST } from '../../../fields'

const InstagramAccountCheckbox = ({ formik }) => {
  const facebookPages = useSelector(facebookPagesSelector)
  const facebookPagesIsLoading = useSelector(facebookPagesIsLoadingSelector)
  const facebookPagesWasLoaded = useSelector(facebookPagesWasLoadedSelector)

  const { values, setFieldValue } = formik

  const socialPage = values[SOCIAL_MEDIA_POST]

  const selectedPage = facebookPages.find(page => page.id === socialPage)
  const instagramBusinessAccountId = selectedPage?.instagram_business_account_id
  const instagramBusinessAccountName = selectedPage?.instagram_business_account_username

  useEffect(() => {
    // We always have only one instagram account, so we don't show dropdown with accounts, just automatically select it
    if (instagramBusinessAccountId) {
      setFieldValue(LINKED_INSTAGRAM_ACCOUNT, instagramBusinessAccountId)
    } else {
      setFieldValue(LINKED_INSTAGRAM_ACCOUNT, '')
    }
  }, [instagramBusinessAccountId, setFieldValue])

  // If socialPage is not selected or it's selected, but it doesn't have instagram account, we don't show checkbox
  if (!socialPage || (facebookPagesWasLoaded && !instagramBusinessAccountId)) {
    return null
  }
  // Only "api/facebook/pages" point has instagram_business_account_id field, that's why we show skeleton when it's loading
  return facebookPagesIsLoading ? (
    <InstagramAccountSkeleton />
  ) : (
    <>
      <Checkbox
        id="checkbox_include_linked_instagram_account"
        title="Include linked Instagram account"
        checked={values[INCLUDE_LINKED_INSTAGRAM_ACCOUNT]}
        onCheck={() => setFieldValue(INCLUDE_LINKED_INSTAGRAM_ACCOUNT, !values[INCLUDE_LINKED_INSTAGRAM_ACCOUNT])}
      />
      <p>
        If this box is checked any posts with brand keyword mentions on the ‘{instagramBusinessAccountName}’ Instagram
        page will also be included in the report.
      </p>
    </>
  )
}

export default InstagramAccountCheckbox
